import { type AroundATimeState, type TimeRangeSelectionMode } from '@chronosphereio/chrono-ui';
import { useMemo, useState } from 'react';
import { type ErrorOptionKey } from '../utils/options';

/**
 * State handling for the TimeRangeSelectPanel
 */
export function useTimeRangeSelectPanelState() {
  const [timeRangeSelectionMode, setTimeRangeSelectionMode] = useState<TimeRangeSelectionMode>('fromTo');
  const [duration, setDuration] = useState('');
  const [center, setCenter] = useState('');
  const aroundATime = useMemo<AroundATimeState>(
    () => ({ center, duration, setCenter, setDuration }),
    [center, duration]
  );
  const [inputError, setInputError] = useState<false | ErrorOptionKey>(false);

  return useMemo(
    () => ({
      aroundATime,
      timeRangeSelectionMode,
      setTimeRangeSelectionMode,
      inputError,
      setInputError,
    }),
    [aroundATime, timeRangeSelectionMode, setTimeRangeSelectionMode, inputError, setInputError]
  );
}
